<template>
  <sweet-modal ref="modal-public-link" width="600px" blocking hide-close-button>
    <section v-if="site && !$isBundle()">
      <h1 class="mt-4">{{ $t("ct-public-link-publish") }}</h1>
      <h2 class="mt-2 mb-4">{{ $t("ct-public-link-for-copy") }}</h2>
      <div class="card p-2 flex-row">
        <p class="flex-1 m-1 link-text w-100 overflow-hidden">
          {{
            `${appUrl}/#/website/public-link/${site.encrypted_id}`
          }}
        </p>
        <input
          type="hidden"
          id="public-link"
          :value="`${appUrl}/#/website/public-link/${site.encrypted_id}`"
        />
        <button @click="copy" data-ba-i="public-link">
          <i class="svg-icon svgi-copy"></i>
        </button>
      </div>

      <div class="d-md-flex mt-3" v-if="site.type !== 'static_import'">
        <div class="d-flex align-items-center enable-sync-script mr-3">
          <toggle-button-component
            :checked="site.template_tag"
            @change="templateTag"
          />
          <span v-text="$t('ct-template-tags')" />
        </div>
        <div
          class="d-flex align-items-center enable-sync-script mt-2 mt-md-0"
          v-show="site.dominio !== null"
        >
          <toggle-button-component
            :checked="site.is_mirror"
            @change="templateMirror"
          />
          <span v-text="$t('ct-website-mirror')" />
        </div>
      </div>

      <div class="alert alert-success mt--3" role="alert" v-show="copy_success">
        {{ $t("ct-copy-success") }}!
      </div>
    </section>

    <!-- Premium templates cannot be transfered -->
    <div v-else>
      <p>{{ $t('ct-plan-limited-transfer') }}</p>
    </div>

    <button
      slot="button"
      class="btn btn-outline-light"
      @click.prevent="$emit('openPublicLink', false)"
    >
      {{ $t("ct-cancel") }}
    </button>

    <button
      slot="button"
      class="btn btn-danger ml-0"
      @click.prevent="disablePublicLink"
      v-if="site && !$isBundle()"
    >
      {{ $t("ct-link-disable") }}
    </button>
  </sweet-modal>

</template>

<script>
import { SweetModal } from "sweet-modal-vue";
import { enable, disable } from "./../../../../js/services/editor/publicLink";
import { updateType } from "./../../../../js/services/editor/template";

import ToggleButtonComponent from "../../../commons/ToggleButtonComponent";

export default {
  name: "SitePublicLink",
  components: { SweetModal, ToggleButtonComponent },
  props: ["show", "action", "site"],

  data() {
    return {
      copy_success: false,
    };
  },

  watch: {
    show: function (value) {
      if(this.action == "active" && !this.$isBundle()){
        this.activePublishLink();
      } else {
        if (value) this.$refs["modal-public-link"].open();
        else this.$refs["modal-public-link"].close();
      }
    },
  },

  computed: {
    appUrl() {
      return typeof process.env.APP_URL !== 'undefined' ? process.env.APP_URL : 'https://cheetah-editor.builderall.com';
    }
  },

  methods: {
    templateTag(data) {
      this.site.template_tag = data;

      let value = 0;
      if (this.site.template_tag) {
        value = 1;
      }

      updateType({
        id_website: this.site.encrypted_id,
        value: value,
        type: "tag",
      }).then((res) => {
        // console.log(res);
      });
    },

    templateMirror(data) {
      this.site.is_mirror = data;

      let value = 0;
      if (this.site.is_mirror) {
        value = 1;
      }

      updateType({
        id_website: this.site.encrypted_id,
        value: value,
        type: "mirror",
      }).then((res) => {
        // console.log(res);
      });
    },

    copy() {
      try {
        let toCopy = document.querySelector("#public-link");
        toCopy.setAttribute("type", "text");
        toCopy.select();
        this.copy_success = !!document.execCommand("copy");
        toCopy.setAttribute("type", "hidden");
        window.getSelection().removeAllRanges();

        setTimeout(() => {
          this.copy_success = false;
        }, 1500);
      } catch (err) {
        this.copy_success = false;
      }
    },

    activePublishLink() {
      if (this.action === "active") {
        this.$loading.show();

        enable(this.site)
          .then((response) => {
            if (response.data.success) {
              this.$refs["modal-public-link"].open();
            } else {
              this.$snotify.error(response.data.error);
            }
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.$loading.hide();
          });
      }
    },

    disablePublicLink() {
      this.$loading.show();
      disable(this.site)
        .then((response) => {
          if (response.data.success) {
            this.$emit("openPublicLink", false);
            this.$emit("updateWebsites");
          }
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.$loading.hide();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.sweet-buttons,
.sweet-content-content {
  // font-family: Muli;
}

.sweet-box-actions {
  background: #ff0000;
}

section {
  .card {
    border: 1px solid #dddddd !important;

    > button {
      border: none;
      background: none;

      &:active {
        outline: none;
      }
    }
  }
  h1 {
    font-weight: bold;
    font-size: 20px;
    font-family: Muli;
    color: #434343;
  }

  h2 {
    color: #6e6e6e;
    font-family: Lato;
    font-size: 16px;
  }

  .link-text {
    font-size: 14px;
    color: #656565;
    font-family: Lato;
  }

  span {
    font-size: 11px;
    font-weight: bold;
    color: #5a5959;
    font-family: Muli;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/dashboard/layout/site/SitePublicLink.vue